import Axios, { CancelTokenSource } from "axios";

import { API } from "utils/api-config";

import { defaultErrorResponse } from "./defaults";

import {
    ConfluenceLinks,
    MicrosoftLinks,
} from "store/information-links/information-links-types";

export const loadConfluenceDocumentLinks = async (
    cancelTokenSource?: CancelTokenSource
): Promise<[ConfluenceLinks | null, number]> => {
    const response = await API.get(`/links/confluence-documents`, {
        cancelToken: cancelTokenSource?.token,
    });

    if (!cancelTokenSource?.token.reason) {
        if (!response) {
            return defaultErrorResponse;
        }

        return [response.data, response.status];
    } else {
        throw new Axios.Cancel();
    }
};

export const loadMicrosoftDocumentLinks = async (
    cancelTokenSource?: CancelTokenSource
): Promise<[MicrosoftLinks | null, number]> => {
    const response = await API.get(`/links/microsoft-documents`, {
        cancelToken: cancelTokenSource?.token,
    });

    if (!cancelTokenSource?.token.reason) {
        if (!response) {
            return defaultErrorResponse;
        }

        return [response.data, response.status];
    } else {
        throw new Axios.Cancel();
    }
};

export const loadSeqLogsLink = async (
    cancelTokenSource?: CancelTokenSource
): Promise<[string | null, number]> => {
    const response = await API.get(`/links/seq-logs`, {
        cancelToken: cancelTokenSource?.token,
    });

    if (!cancelTokenSource?.token.reason) {
        if (!response) {
            return defaultErrorResponse;
        }

        return [response.data, response.status];
    } else {
        throw new Axios.Cancel();
    }
};
